import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getSupportedResourceEntitlementsLogsActions} from 'src/openapi/admin/apis/EntitlementLogDictionariesApi';
import {useAppDispatch} from 'src/store/hooks';

export const useGetEntitlementResourceActionTypeDictionary = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getSupportedResourceEntitlementsLogsActions(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
